import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import SystemSettingBlock from './components/SystemSettingBlock';

const { Cell } = ResponsiveGrid;

const SystemSetting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="推播設置"
        breadcrumbs={[
          {
            name: '設置頁面',
          },
          {
            name: '推播設置',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <SystemSettingBlock />
    </Cell>
  </ResponsiveGrid>
);

export default SystemSetting;
